import { AlertCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AppNavbar from "@/components/common/AppNavbar";
import Footer from "@/components/Footer";
import { logout } from "@/redux/auth/authSlice";
import { RootState } from "@/store";

export default function Page404() {
  const [animate, setAnimate] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);

  const handleButtonClick = () => {
    if (user?.id) {
      // User is logged in, logout
      dispatch(logout());
      window.location.href = "/";
    } else {
      // User is not logged in, go to dashboard
      window.location.href = "/";
    }
  };

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    // Outer structure defaults to your global theme variables
    <div className="flex min-h-screen flex-col bg-background text-foreground transition-colors duration-300">
      
      {/* Fixed top Navbar */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <AppNavbar />
      </div>

      {/* Content wrapper with critical top padding to prevent layout clipping */}
      <div className="flex flex-grow items-center justify-center px-4 pt-24 pb-12 text-center md:pt-32">
        <div>
          {/* Accent colored icon matching dark/light context */}
          <AlertCircle
            className={`mx-auto mb-8 text-primary transition-all duration-700 ${
              animate ? "scale-110 opacity-100" : "scale-75 opacity-0"
            }`}
            size={120}
            strokeWidth={1.5}
          />

          <h1
            className={`text-7xl font-extrabold leading-none tracking-tight sm:text-[8rem] transition-opacity duration-1000 ${
              animate ? "opacity-100" : "opacity-0"
            }`}
          >
            404
          </h1>

          <p
            className={`mb-8 mt-4 max-w-md mx-auto text-xl text-muted-foreground transition-opacity delay-200 duration-1000 md:text-2xl ${
              animate ? "opacity-100" : "opacity-0"
            }`}
          >
            Oops! The page you’re looking for doesn’t exist or moved to a
            different location.
          </p>

          <button
            className="inline-block rounded-md px-6 py-3 font-semibold text-primary-foreground shadow transition-colors hover:bg-primary/90 dark:bg-primary-foreground dark:text-primary dark:hover:bg-primary-foreground/90"
            onClick={handleButtonClick}
          >
            {user?.id ? "Logout" : "Go to Hareeng"}
          </button>

        </div>
      </div>

      {/* Full-width adaptive Footer */}
      <div className="w-full">
        <Footer />
      </div>
    </div>
  );
}
